import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material';
import ReactCompareImage from 'react-compare-image';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';

const CompareImage = (props) => {

  const [ imagesIndex, setImagesIndex ] = useState(0);

  const images = [
    {
      designer: "/assets/webp/designer-game-room.webp",
      render: "/assets/webp/render-game-room.webp",
    },
    {
      designer: "/assets/webp/designer-kitchen-mid-century.webp",
      render: "/assets/webp/render-kitchen-mid-century.webp",
    },
    {
      designer: "/assets/webp/designer-family-room-and-kitchen.webp",
      render: "/assets/webp/render-family-room-and-kitchen.webp",
    },
    {
      designer: "/assets/webp/designer-blue-onyx.webp",
      render: "/assets/webp/render-blue-onyx.webp",
    },
    {
      designer: "/assets/webp/designer-villa.webp",
      render: "/assets/webp/render-villa.webp",
    }
  ]

  useEffect(() => {
    const randomImage = Math.floor(Math.random() * images.length);
    setImagesIndex(randomImage);

    return () => {}
  }, [images.length])

  return (
    <Box
      sx={{
        "& div:nth-child(4) > div, & div:nth-child(5) > div": {
          borderRadius: "4px",
          bottom: "0px !important",
          fontSize: 14,
          top: "initial !important",
        }
      }}
    >
      <ReactCompareImage
        height={750}
        width={1500}
        loading="lazy"
        handle={
          <Box
            className="handle"
            sx={{
              alignItems: "center",
              backgroundColor: "#b71c1c",
              borderRadius: "50%",
              color: "#ffffff",
              display: "flex",
              fontSize: 16,
              height: 30,
              justifyContent: "center",
              width: 30,
            }}
          >
            <SwapHorizIcon />
          </Box>
        }
        leftImage={
          process.env.NODE_ENV === 'development' ?
            images[imagesIndex].render :
            "/wp-content/themes/personal-architect/" + images[imagesIndex].render
        }
        leftImageLabel="Rendered"
        rightImage={
          process.env.NODE_ENV === 'development' ?
            images[imagesIndex].designer :
            "/wp-content/themes/personal-architect/" + images[imagesIndex].designer
        }
        rightImageLabel="Designer"
        sliderLineColor="#b71c1c"
      />
    </Box>
  )
}



export default CompareImage